import { useApiContext } from 'react-easyrocket';
import { AuthorizedButtons } from './components/AuthorizedButtons';
import { UnauthorizedButtons } from './components/UnauthorizedButtons';

export const SidebarButtons = () => {
  const { isAuthenticated } = useApiContext();

  return (
    <div className="w-full flex justify-center items-center gap-3">
      {isAuthenticated ? <AuthorizedButtons /> : <UnauthorizedButtons />}
    </div>
  );
};
